export function isSectionLinkActive(linkHref, sectionId, currentHref) {
  const linkUrl = new URL(linkHref, currentHref);
  const currentUrl = new URL(currentHref);
  return linkUrl.pathname === currentUrl.pathname && linkUrl.hash === `#${sectionId}`;
}

export function init() {
  const header = document.getElementById('nav-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const navLinks = document.querySelectorAll('.nav-items a:not(.nav-contact)');

  const sectionObs = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      const href = `#${target.id}`;
      navLinks.forEach(link => {
        const active = isSectionLinkActive(link.href, target.id, window.location.href);
        link.classList.toggle('active', active);
        if (active) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('section[id]').forEach(s => sectionObs.observe(s));

  const burger = document.getElementById('nav-burger');
  const menu = document.getElementById('nav-items');

  function closeMenu() {
    if (!menu || !burger) return;
    menu.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    const themeBtn = document.getElementById('theme-btn');
    if (themeBtn) themeBtn.tabIndex = 0;
    burger.focus();
  }

  const themeBtn = document.getElementById('theme-btn');

  burger?.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (themeBtn) themeBtn.tabIndex = open ? -1 : 0;
    if (open) {
      const firstLink = menu.querySelector('a');
      firstLink?.focus();
    }
  });

  menu?.addEventListener('click', e => {
    if (e.target.closest('a') && menu.classList.contains('open')) closeMenu();
  });

  // Escape closes menu
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && menu?.classList.contains('open')) {
      closeMenu();
    }
  });

  // Focus trap while mobile menu is open
  if (menu && burger) {
    menu.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      if (!menu.classList.contains('open')) return;

      const focusable = menu.querySelectorAll('a, button');
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }
}
